module.exports = __webpack_public_path__ + "static/img/14002011.aa3d7d95.png";